<main class="min-dvh-100 w-100 d-flex justify-content-center align-items-center bg-white px-5">
    <section class="w-100 mx-auto d-flex flex-column justify-content-center bg-white">
        <div class="w-100 py-4">
            <div class="text-center mb-4">
                <div class="fw-medium lh-1">Bem-vindo ao</div>
                <h1 class="mb-2 fw-medium"><strong>Ariel PWA</strong></h1>
                <div class="text-body-secondary fs-6">Versão {{ version }}</div>
            </div>

            <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
                <div class="mb-3">
                    <input id="username" #usernameModel="ngModel" [(ngModel)]="username" name="username"
                        type="email" autocomplete="email" inputmode="email" class="form-control form-control-lg auth-field"
                        [pattern]="emailPattern"
                        [class.auth-field-valid]="isEmailStructurallyValid(username)"
                        [class.auth-field-invalid]="(f.submitted || usernameModel.touched || username.trim().length > 0) && !isEmailStructurallyValid(username)"
                        [class.is-invalid]="(f.submitted || usernameModel.touched || username.trim().length > 0) && !isEmailStructurallyValid(username)"
                        placeholder="Email" required />
                    @if ((f.submitted || usernameModel.touched || username.trim().length > 0) && !isEmailStructurallyValid(username)) {
                    <div class="invalid-feedback d-block">Informe um email válido para continuar.</div>
                    }
                </div>

                <div class="mb-3">
                    <input id="password" #passwordModel="ngModel" [(ngModel)]="password" name="password"
                        type="password" autocomplete="current-password" class="form-control form-control-lg auth-field"
                        [class.auth-field-valid]="isPasswordFilled(password)"
                        [class.auth-field-invalid]="(f.submitted || passwordModel.touched) && !isPasswordFilled(password)"
                        [class.is-invalid]="(f.submitted || passwordModel.touched) && !isPasswordFilled(password)"
                        placeholder="Senha" required />
                    @if ((f.submitted || passwordModel.touched) && !isPasswordFilled(password)) {
                    <div class="invalid-feedback d-block">Senha é obrigatória.</div>
                    }
                </div>

                <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading || !isEmailStructurallyValid(username) || !isPasswordFilled(password)">
                    @if (loading) {
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    <span>Entrando...</span>
                    } @else {
                    <span>Entrar</span>
                    }
                </button>

                <a class="btn btn-link w-100 mt-3" routerLink="/recover-password">
                    Esqueci minha senha
                </a>
            </form>
        </div>
    </section>
</main>
